import * as React from "react";
export default React.memo(function SvgClose(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" role="presentation" {...props}><path d="m13.63 3.65-1.28-1.27L8 6.73 3.64 2.38 2.37 3.65l4.35 4.36-4.34 4.34 1.27 1.28L8 9.28l4.35 4.36 1.28-1.28-4.36-4.35 4.36-4.36z" /></svg>;
});